var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"subtitle-guidance"},_vm._l((_vm.tips),function(t,i){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.step == i),expression:"step == i"}],staticClass:"subtitle-tip-box",style:({
      width: t.button.w + 'px',
      height: t.button.h + 'px',
      top: t.button.y + 'px',
      left: t.button.x + 'px'
    })},[(i == 1)?_c('div',{staticClass:"tip-box-timeline"},[_c('div',[_vm._v(_vm._s(t.button.text + i))])]):(i == 2)?_c('div',{staticClass:"tip-box-ai"},[_c('div',{staticClass:"icon"}),_vm._v(" "),_c('div',[_vm._v("智能识别")])]):_c('div',{staticClass:"tip-box-btn"},[_vm._v(_vm._s(t.button.text))]),_vm._v(" "),_c('div',{staticClass:"tip-box-line",style:({
        width: t.tip.w + 'px',
        height: t.tip.h + 'px',
        top: t.tip.y + 'px',
        left: t.tip.x + 'px',
        backgroundImage: ("url(" + (t.tip.url) + ")")
      })}),_vm._v(" "),_c('div',{staticClass:"tip-box-content",style:({
        width: t.content.w + 'px',
        height: t.content.h + 'px',
        top: t.content.y + 'px',
        left: t.content.x + 'px'
      })},[_c('p',[_vm._v(_vm._s(t.content.text))]),_vm._v(" "),_c('div',{on:{"click":_vm.next}},[_vm._v(_vm._s(i != 3 ? '下一步' : 'OK'))])])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90576d5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subtitle/subtitleGuidanceOld.vue
// module id = null
// module chunks = 